import { TaskStatusOptions } from "../gateways/cms/task";
import { SelectFilter } from "./SelectFilter";

const options = TaskStatusOptions.map(({ id, name }) => ({ value: String(id), label: name }));

export interface Props {
    value: string[];
    onChange: (value: string[]) => unknown;
}

export function SelectTaskStatusFilter({ value, onChange }: Props) {
    return <SelectFilter options={options} value={value} onChange={onChange} />;
}
